"use client"

import { BarElement, CategoryScale, Chart, Colors, Legend, LinearScale, Title } from "chart.js"
import ChartDataLabels from "chartjs-plugin-datalabels"
import { ReactNode } from "react"
import { trpc } from "../../domains/trpc/trpc"

Chart.register(CategoryScale)
Chart.register(LinearScale)
Chart.register(BarElement)
Chart.register(Title)
Chart.register(ChartDataLabels)
Chart.register(Colors)
Chart.register(Legend)

Chart.defaults.color = "#000"
Chart.defaults.font.size = 18

interface Props {
    children: ReactNode
}

function Layout({ children }: Props) {
    return <>{children}</>
}

export default trpc.withTRPC(Layout)
